module.exports = __webpack_public_path__ + "img/calendar2-check.6ea3d8e7.svg";